/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QueueSummary } from './QueueSummary';
import {
    QueueSummaryFromJSON,
    QueueSummaryFromJSONTyped,
    QueueSummaryToJSON,
    QueueSummaryToJSONTyped,
} from './QueueSummary';
import type { TaskQueueItem } from './TaskQueueItem';
import {
    TaskQueueItemFromJSON,
    TaskQueueItemFromJSONTyped,
    TaskQueueItemToJSON,
    TaskQueueItemToJSONTyped,
} from './TaskQueueItem';
import type { StreakIndicator } from './StreakIndicator';
import {
    StreakIndicatorFromJSON,
    StreakIndicatorFromJSONTyped,
    StreakIndicatorToJSON,
    StreakIndicatorToJSONTyped,
} from './StreakIndicator';

/**
 * 
 * @export
 * @interface OperatorDashboardView
 */
export interface OperatorDashboardView {
    /**
     * 
     * @type {string}
     * @memberof OperatorDashboardView
     */
    userId?: string;
    /**
     * 
     * @type {Date}
     * @memberof OperatorDashboardView
     */
    computedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OperatorDashboardView
     */
    windowStart?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OperatorDashboardView
     */
    windowEnd?: Date;
    /**
     * 
     * @type {Array<TaskQueueItem>}
     * @memberof OperatorDashboardView
     */
    queue?: Array<TaskQueueItem>;
    /**
     * 
     * @type {StreakIndicator}
     * @memberof OperatorDashboardView
     */
    streak?: StreakIndicator;
    /**
     * 
     * @type {QueueSummary}
     * @memberof OperatorDashboardView
     */
    summary?: QueueSummary;
}

/**
 * Check if a given object implements the OperatorDashboardView interface.
 */
export function instanceOfOperatorDashboardView(value: object): value is OperatorDashboardView {
    return true;
}

export function OperatorDashboardViewFromJSON(json: any): OperatorDashboardView {
    return OperatorDashboardViewFromJSONTyped(json, false);
}

export function OperatorDashboardViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperatorDashboardView {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'computedAt': json['computedAt'] == null ? undefined : (new Date(json['computedAt'])),
        'windowStart': json['windowStart'] == null ? undefined : (new Date(json['windowStart'])),
        'windowEnd': json['windowEnd'] == null ? undefined : (new Date(json['windowEnd'])),
        'queue': json['queue'] == null ? undefined : ((json['queue'] as Array<any>).map(TaskQueueItemFromJSON)),
        'streak': json['streak'] == null ? undefined : StreakIndicatorFromJSON(json['streak']),
        'summary': json['summary'] == null ? undefined : QueueSummaryFromJSON(json['summary']),
    };
}

export function OperatorDashboardViewToJSON(json: any): OperatorDashboardView {
    return OperatorDashboardViewToJSONTyped(json, false);
}

export function OperatorDashboardViewToJSONTyped(value?: OperatorDashboardView | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'computedAt': value['computedAt'] == null ? undefined : ((value['computedAt']).toISOString()),
        'windowStart': value['windowStart'] == null ? undefined : ((value['windowStart']).toISOString()),
        'windowEnd': value['windowEnd'] == null ? undefined : ((value['windowEnd']).toISOString()),
        'queue': value['queue'] == null ? undefined : ((value['queue'] as Array<any>).map(TaskQueueItemToJSON)),
        'streak': StreakIndicatorToJSON(value['streak']),
        'summary': QueueSummaryToJSON(value['summary']),
    };
}

